import {
	CHAT_MESSAGE_CONTEXT_MENU,
	CLICKED_OUTSIDE_POPUP, GAME_FILTER_CONTEXT_MENU, POPUP_CLOSE, ROOM_CONTEXT_MENU,
	POPUP_RESIZE_PROBABLY_HAPPENED,
	STREAM_CLICK_POPUP_OPEN,
	USER_CLICK_POPUP_OPEN, USER_SEARCH_HEADER_BAR_CLOSE, USER_SEARCH_HEADER_BAR_OPEN
} from '../actions/popups';
import PopupTypes from '../../../components/PopupTypes';

const activePopupClear = {
	activePopupUser: null,
	activePopupStream: null,
	activePopupChatMessage: null,
	activePopupPreferredGameFilter: null,
	activePopupChatRoomId: null,
	activePopupChatRoom: null,
	activePopupRoomMenu: null,
	activePopupType: null,
	activePopupCoordinates: null,
	activePopupChatMessageId: null,
	highlightedMessageIds: {},
	currentClickedMessageId: null,
};
const initialState = {
	...activePopupClear,
	resizeTriggerIndex: 1,
	userSearchHeaderBarOpen: false,
};
delete activePopupClear.resizeTriggerIndex;

export default (state = initialState, action) => {
	const coordinateStuff = {};
	if(action && action.payload && action.payload.coordinates) {
		coordinateStuff.activePopupCoordinates = action.payload.coordinates;
	}
	switch(action.type) {
		case USER_SEARCH_HEADER_BAR_OPEN: {
			return {
				...state,
				userSearchHeaderBarOpen: true,
			};
		}
		case USER_SEARCH_HEADER_BAR_CLOSE: {
			return {
				...state,
				userSearchHeaderBarOpen: false,
			};
		}
		case GAME_FILTER_CONTEXT_MENU: {
			return {
				...state,
				...activePopupClear,
				...coordinateStuff,
				activePopupType: PopupTypes.GAME_FILTER_CONTEXT_MENU,
				activePopupPreferredGameFilter: action.payload.preferredGameFilter,
			};
		}
		case CHAT_MESSAGE_CONTEXT_MENU: {
			return {
				...state,
				...activePopupClear,
				...coordinateStuff,
				activePopupType: PopupTypes.CHAT_MESSAGE_MENU,
				activePopupChatMessage: action.payload.chatMessage,
				activePopupUser: action.payload.chatMessage.player,
			};
		}
		case ROOM_CONTEXT_MENU: {
			return {
				...state,
				...activePopupClear,
				...coordinateStuff,
				activePopupType: PopupTypes.ROOM_MENU,
				activePopupChatRoom: action.payload.chatRoom,
				activePopupRoomMenu: action.payload.menu,
			};
		}
		case POPUP_RESIZE_PROBABLY_HAPPENED: {
			return {
				...state,
				resizeTriggerIndex: state.resizeTriggerIndex + 1
			};
		}
		case STREAM_CLICK_POPUP_OPEN:
			return {
				...state,
				...activePopupClear,
				...coordinateStuff,
				activePopupStream: action.payload.stream,
				activePopupType: PopupTypes.STREAM_POPUP,
			};
		case USER_CLICK_POPUP_OPEN:
			const contextData = action.payload.contextData || {};
			return {
				...state,
				...activePopupClear,
				...coordinateStuff,
				activePopupUser: action.payload.user,
				activePopupType: action.payload.popupType,
				activePopupChatRoomId: contextData.chat_room_id,
				activePopupChatMessageId: contextData.chat_message_id
			};
		case POPUP_CLOSE:
			return {
				...state,
				...activePopupClear,
			};
		default:
			return state;
	}
}